import { Moment } from 'moment';
import moment from 'moment';
import { prepareDateWithUTCDrift } from '../../../Components/Calendar/calendar.helper';

export const calculateDatesAndTimesForServiceSchedule = ({
	date,
	timeFrom,
	timeTo,
}: {
	date: Moment;
	timeFrom?: Moment;
	timeTo?: Moment;
}) => {
	const timeFromMoment = moment(timeFrom);
	const timeToMoment = moment(timeTo);
	timeFrom = date.clone().set({
		hour: timeFromMoment.hours(),
		minute: timeFromMoment.minutes(),
		second: timeFromMoment.seconds(),
	});
	timeTo = date.clone().set({
		hour: timeToMoment.hours(),
		minute: timeToMoment.minutes(),
		second: timeToMoment.seconds(),
	});

	const dateFrom = prepareDateWithUTCDrift(
		date,
		timeFrom.clone().set({
			hour: 0,
			minute: 0,
			second: 0,
		}),
	).format();
	let dateTo = prepareDateWithUTCDrift(
		date,
		timeTo.clone().set({
			hour: 23,
			minute: 59,
			second: 59,
		}),
	).format();

	const [, dateFromUTCOffset] = dateFrom.split('+');
	const [dateToWithoutUTCOffset, dateToUTCOffset] = dateTo.split('+');

	if (dateFromUTCOffset !== dateToUTCOffset) {
		dateTo = `${dateToWithoutUTCOffset}+${dateFromUTCOffset}`;
	}

	return { dateTo, dateFrom, timeTo, timeFrom };
};
